import { render, staticRenderFns } from "./IcoConiclex.vue?vue&type=template&id=2bc2dcbe"
import script from "./IcoConiclex.vue?vue&type=script&lang=js"
export * from "./IcoConiclex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports